import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { getValueForBreakpoint } from 'utils/helpers'
import { useClientWidth } from 'utils/hooks'
import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitMargins } from '../../SkeletonUnit.h'
import { breakpointsDirectionInfoBlock } from './breakpoints'

export interface IPlayerInfoBlockSkeletonUnitProps extends ISkeletonUnitProps {
  breakpointsDirection?: {}
}

export const PlayerInfoBlockSkeletonUnit = ({
  children,
  margins = SkeletonUnitMargins.SIZE_50,
  breakpointsDirection = breakpointsDirectionInfoBlock,
  ...rest
}: IPlayerInfoBlockSkeletonUnitProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const validDirection = breakpointsDirection
    ? getValueForBreakpoint(clientWidth, breakpointsDirection)
    : rest.direction

  return (
    <SkeletonUnit direction={validDirection} margins={margins} {...rest}>
      {children}
    </SkeletonUnit>
  )
}
